import Link from 'next/link';

import useRoutePaths from '@/src/hooks/useRoutePaths';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, SectionContainer, Text} from '../../../ui';
import css from '../styles/signInBlock.module.css';

const MobileSingInBlock = () => {
  const {SIGN_IN_ROUTE} = useRoutePaths();

  return (
    <div className={css.mainSignInWrapper}>
      <SectionContainer>
        <div className={css.singInWrapperMob}>
          <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_17}>
            <TextLocal id="userType.has-account-q" />
          </Text>
          <div className={css.singInWrapper}>
            <Link href={SIGN_IN_ROUTE.getLink()}>
              <a>
                <Button
                  height={Button.HEIGHT.SMALL}
                  color={Button.COLOR.SECONDARY}
                >
                  <TextLocal id="userType.sign-in" />
                </Button>
              </a>
            </Link>
          </div>
        </div>
      </SectionContainer>
    </div>
  );
};

export default MobileSingInBlock;
